import script from "./TotalUserDetailView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TotalUserDetailView.vue?vue&type=script&setup=true&lang=ts"

import "./TotalUserDetailView.vue?vue&type=style&index=0&id=283b0b7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-283b0b7d"]])

export default __exports__